var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    rx: 10,
    fill: "#F4E2FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M20.146 37.6028C21.391 37.6028 22.411 38.6228 22.411 39.8828C22.411 41.1278 21.391 42.1478 20.146 42.1478C18.886 42.1478 17.866 41.1278 17.866 39.8828C17.866 38.6228 18.886 37.6028 20.146 37.6028ZM37.021 37.6028C38.266 37.6028 39.286 38.6228 39.286 39.8828C39.286 41.1278 38.266 42.1478 37.021 42.1478C35.761 42.1478 34.741 41.1278 34.741 39.8828C34.741 38.6228 35.761 37.6028 37.021 37.6028Z",
    fill: "#FF81AE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1684 12.7497L13.3212 12.762L16.8987 13.302C17.4087 13.3935 17.7837 13.812 17.8287 14.322L18.1137 17.682C18.1587 18.1635 18.5487 18.5235 19.0287 18.5235H39.2862C40.2012 18.5235 40.8012 18.8385 41.4012 19.5285C42.0012 20.2185 42.1062 21.2085 41.9712 22.107L40.5462 31.947C40.2762 33.8385 38.6562 35.232 36.7512 35.232H20.3862C18.3912 35.232 16.7412 33.702 16.5762 31.7235L15.1962 15.372L12.9312 14.982C12.3312 14.877 11.9112 14.292 12.0162 13.692C12.1212 13.077 12.7062 12.672 13.3212 12.762L13.1684 12.7497ZM34.3512 24.072H30.1962C29.5662 24.072 29.0712 24.567 29.0712 25.197C29.0712 25.812 29.5662 26.322 30.1962 26.322H34.3512C34.9812 26.322 35.4762 25.812 35.4762 25.197C35.4762 24.567 34.9812 24.072 34.3512 24.072Z",
    fill: "#FF81AE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPos);
export default __webpack_public_path__ + "static/media/ic_pos.88f577d73f64191c4929aa250519bd85.svg";
export { ForwardRef as ReactComponent };